import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
import _ from "lodash";
import { UAParser } from "ua-parser-js";
import lang from "../lang.js";

import Router from '../router';

import Cart from "./modules/cart";
import Theme from "./modules/theme";

import DefaultTheme from "../themes/default";
import DefaultCleanTheme from "../themes/default-clean";
import whiteBlackTheme from "../themes/white-black";
import whiteBlackCleanTheme from "../themes/white-black-clean";
import DarkTheme from "../themes/dark";
import DarkCleanTheme from "../themes/dark-clean";
import { saveNewSessionId } from "../utils/sessions";
import { sortCartByAdditions } from "../utils";
import fallbackPlaceholder from "../assets/images/placeholder-image.jpeg";

axios.defaults.baseURL =process.env.VUE_APP_API_BASE_PATH;

Vue.use(Vuex);

const userAgent = new UAParser().getResult();

// console.log("userAgent details",userAgent);

export default new Vuex.Store({
  state: {
    currentTheme: localStorage.getItem("theme") || "default",
    themes: {
      default: DefaultTheme,
      "default-clean": DefaultCleanTheme,
      "white-black": whiteBlackTheme,
      "white-black-clean": whiteBlackCleanTheme,
      dark: DarkTheme,
      "dark-clean": DarkCleanTheme,
    },
    languageLocales: {
      de: {
        locale: "de-DE",
        currency: "EUR",
      },
      nl: {
        locale: "nl-NL",
        currency: "EUR",
      },
      fr: {
        locale: "fr-FR",
        currency: "EUR",
      },
      en: {
        locale: "en-US",
        currency: "EUR",
      },
    },
    pageLoading: true,
    isThemeLoading: true,
    infiniteScroll: undefined,
    loadingItems: false,
    menuHashAvailable: true,
    language: "",
    currency: "€",
    appUrl: process.env.VUE_APP_URL,
    errorEmail: false,
    languagesCount: 0,
    landingPageHash: "",
    landingPage: [],
    menuId: "",
    menuHash: "",
    orderingSecurityCodeHash: "",
    categoryId: "",
    subCategoryId: "",
    isOrderingEnabled: false,
    latAddressClient: "",
    longAddressClient: "",
    busNumber: "",
    processBarCurrentItem: 1,
    processBarIndex: 1,
    processCurrentName: "Category",
    currentBottomIcon: "cart",
    isCartViewShown: "false",
    isKiosk: false,
    menu: {},
    selectedMenuCategory: {},
    parentSelectedMenuCategory: {},
    selectedMenuItem: {},
    discountCodeInfo: {},
    menuCategories: [],
    menuCategoriesCategories: [],
    menuSubCategories: [],
    menuItems: [],
    menuSubItems: [],
    orderData: [],
    orderStatus: [],
    selectedModifiers: [],
    isListDisplayed: true,
    isMobileDevice: true,
    isSubSubCategory: false,
    totalDaysVisible: 0,
    isIOSChrome: false,
    calculatedDistanceHomeDelivery: 0,
    address: "",
    city: "",
    zip: "",
    country: "",
    isSwipeOpen: false,
    showFee: true,
    floatButtonLabel: "",
    showTable: false,
    showPayment: false,
    showForm: false,
    showTableManual: false,
    processStack: [],
    buttonStack: [],
    isCickable: "",
    currentHash: "",
    currentKioskMode: "",
    hasKiosk: false,
    name: "",
    modifierNumber: 0,
    isSafari: false,
    isIOS: false,
    isDelivery: true,
    paidFreeItem: false,
    upselling: [],
    visitorContactDetails: {
      name: "",
      email: "",
      phone: "",
      marketingConsent: false,
    },
    cancelOrder: false,
    currentAddressesInSearch: "",
    idleTimer: null,
    showIdleTimerModal: false,
    routeName: "",
    itemPrice: 0,
    sessionId: 0,
    ccvPaying: false,
    screensaver: false,
    screensaverTimer: undefined,
    minSelectedAddition: 0,
    minSelectedAdditionTotal: 0,
    minModifiersCheck: [],
    userAgent: {
      ...userAgent,
      device: !userAgent.device.type
        ? {
            type: "desktop",
          }
        : userAgent.device,
    },
    minSelectedAdditionComboTotal: 0,
    minModifierComboCount: 0,
    paymentUrl: null,
    paymentError: false,
    isCategorySubItem: false,
    landingsPageDelivery: false,
    // allRequiredModifersComboDeal: true,
    comboItemSelectionStep: 0,
    modifierSelectionStep: 0,
    searchItemInput: "",
    isSearchKiosk: false,
    identificationFormData: {
      customIdentifier: "", 
    },
    member: {},
    loyaltyPoints: 0,
    comoPayment: false,
    menuRound: '',
    isUpselling: false,
    modifiersSelectionGroups: 0,
    minimumAgeProduct: '',
    additionSteps: [],
    modifierSelectionIndex: 0,
  },
  mutations: {
    setIsUpselling(state, value) {
      state.isUpselling = value; 
    },
    updateMinimumAgeProduct(state, data) {
      state.minimumAgeProduct = data
    },
    updateModifiersSelectionGroups(state, data) {
      state.modifiersSelectionGroups = data
    },
    saveAdditionStepsArray(state, data) {
      state.additionSteps = data
    },
    resetModifierSelectionStep(state) {
      state.modifierSelectionIndex = 0
      state.modifierSelectionStep = 0
    },
    updateCustomIdentifier(state, data) {
      state.identificationFormData.customIdentifier = data;
    },
    updateMember(state, data) {
      sessionStorage.removeItem("comoMember");
      state.member = data.membership;
      if (data.membership) {
        sessionStorage.setItem("comoMember", JSON.stringify(data.membership));
      }
    },
    updateComoPayment(state, value) {
      state.comoPayment = value
    },
    updateIsSearchKiosk(state, value) {
      state.isSearchKiosk = value;
    },
    updateSearchItemInput(state, value) {
      state.searchItemInput = value;
    },
    updateIsThemeLoading(state, value) {
      state.isThemeLoading = value;
    },
    updateComboItemSelectionStep(state, value) {
      state.comboItemSelectionStep=value;
    },
    comboItemSelectionStepIncrement(state) {
      state.comboItemSelectionStep++;
    },
    comboItemSelectionStepDecrement(state){
      state.comboItemSelectionStep--;
    },
    modifierSelectionStepIncrement(state) {
      state.modifierSelectionIndex++;      
      if (state.additionSteps && state.additionSteps.length > 0) {
        // Check the current index and increment it, looping back if necessary
        const currentIndex = state.additionSteps.indexOf(state.modifierSelectionStep);
        const nextIndex = (currentIndex + 1) % state.additionSteps.length;
        state.modifierSelectionStep = state.additionSteps[nextIndex];
      }
    },
    modifierSelectionStepDecrement(state) {
      state.modifierSelectionIndex--;
      if (state.additionSteps && state.additionSteps.length > 0) {
      // Check the current index and decrement it, looping back if necessary
      const currentIndex = state.additionSteps.indexOf(state.modifierSelectionStep);
      const prevIndex = (currentIndex - 1 + state.additionSteps.length) % state.additionSteps.length;
      state.modifierSelectionStep = state.additionSteps[prevIndex];
    }
    },
    setCurrentTheme(state, theme) {
      localStorage.setItem("theme", theme);
      state.currentTheme = theme;
    },
    startPageLoading(state) {
      state.pageLoading = true;
    },
    stopPageLoading(state) {
      state.pageLoading = false;
    },
    loadingItems(state, data) {
      state.loadingItems = data;
    },
    menuHashAvailable(state, data) {
      state.menuHashAvailable = data;
    },
    changeLanguage(state, language) {
      state.language = language;
      localStorage.setItem("language", language);
    },
    updateCurrency(state, currency) {
      state.currency = currency;
    },
    updateMenuHash(state, data) {
      state.menuHash = data;
    },
    updateCategoryId(state, data) {
      let category = state.menuCategories.find(el => el.Id == data);
      state.categoryId = data;
      if (category) {
        state.selectedMenuCategory = category;
      }
    },
    updateErrorEmail(state, data) {
      state.errorEmail = data;
    },
    updateSubCategoryId(state, data) {
      state.subCategoryId = data;
    },
    updateMenu(state, data) {
      state.menu = data;
    },
    updateSelectedMenuCategory(state, data) {
      state.selectedMenuCategory = data;
      state.categoryId = data.Id;
    },
    updateParentSelectedMenuCategory(state, data) {
      state.parentSelectedMenuCategory = data;
    },
    updateMenuCategories(state, data) {
      state.menuCategories = data;
    },
    updateMenuCategoriesCategories(state, data) {
      state.menuCategoriesCategories = data;
    },
    updateMenuSubCategories(state, data) {
      state.menuSubCategories = data;
    },
    updateMenuItems(state, data) {
      state.menuItems = data;
    },
    updateUpselling(state, data) {
      state.upselling.push(data);
    },
    removeupsellingItems(state) {
      state.upselling = [];
    },
    updateMenuSubItems(state, data) {
      state.menuSubItems = data;
    },
    updateVisitorName(state, name) {
      state.visitorContactDetails.name = name;
    },
    updateVisitorEmail(state, email) {
      state.visitorContactDetails.email = email;
    },
    updateBusNumber(state, value) {
      state.busNumber = value;
    },
    updateMenuRound(state, value) {
      state.menuRound = value;
    },
    updateVisitorPhone(state, phone) {
      state.visitorContactDetails.phone = phone;
    },
    updateMarketingConsent(state, status) {
      state.visitorContactDetails.marketingConsent = status;
    },
    enableOrdering(state, status) {
      state.isOrderingEnabled = status;
    },
    updateOrderedData(state, data) {
      state.orderData = data;
    },
    updateOrderStatus(state, status) {
      state.orderStatus = status;
    },
    updateSelectedModifiers(state, data) {
      state.selectedModifiers = data;
    },
    updateOrderingSecurityCodeHash(state, hash) {
      state.orderingSecurityCodeHash = hash;
    },
    updateIsListDisplayed(state, data) {
      state.isListDisplayed = data;
    },
    updateProcessBarCurrentItem(state, value) {
      state.processBarCurrentItem = value;
    },
    updateCurrentBottomIcon(state, value) {
      state.currentBottomIcon = value;
    },
    updateIsCartViewShown(state, value) {
      state.isCartViewShown = value;
    },
    updateIsMobileDevice(state, value) {
      state.isMobileDevice = value;
    },
    updateIsSubSubCategory(state, value) {
      state.isSubSubCategory = value;
    },
    updateTotalDaysVisible(state, value) {
      state.totalDaysVisible = value;
    },
    updateDiscountCodeInfo(state, value) {
      state.discountCodeInfo = value;
    },
    updateLanguagesCount(state, value) {
      state.languagesCount += value;
    },

    updateAddress(state, value) {
      state.address = value;
    },
    updateZip(state, value) {
      state.zip = value;
    },
    updateCountry(state, value) {
      state.country = value;
    },
    updateLatAddressClient(state, value) {
      state.latAddressClient = value;
    },
    updateLongAddressClient(state, value) {
      state.longAddressClient = value;
    },
    updateCalculatedDistanceHomeDelivery(state, value) {
      state.calculatedDistanceHomeDelivery = value;
    },
    updateCity(state, value) {
      state.city = value;
    },
    deleteLanguagesCount(state, value) {
      state.languagesCount = value;
    },
    updateIsSwipeOpen(state, value) {
      state.isSwipeOpen = value;
    },
    updateShowFee(state, value) {
      state.showFee = value;
    },
    updateProcessBarIndex(state, value) {
      state.processBarIndex = value;
    },
    updateProcessCurrentName(state, value) {
      state.processCurrentName = value;
    },
    updateFloatButtonLabel(state, value) {
      state.floatButtonLabel = value;
    },
    updateShowTable(state, value) {
      state.showTable = value;
    },
    updateShowPayment(state, value) {
      state.showPayment = value;
    },
    updateShowForm(state, value) {
      state.showForm = value;
    },
    updateShowTableManual(state, value) {
      state.showTableManual = value;
    },
    updateProcessStack(state, value) {
      state.processStack.push(value);
    },
    deleteProcessStack(state) {
      state.processStack.pop();
    },
    updateButtonStack(state, value) {
      state.buttonStack.push(value);
    },
    deleteButtonStack(state) {
      state.buttonStack.pop();
    },
    updateIsCickable(state, value) {
      state.isCickable = value;
    },
    updateIsKiosk(state, value) {
      state.isKiosk = value;
    },
    addName(state, value) {
      state.name = value;
    },
    updateCurrentHash(state, value) {
      state.currentHash = value;
    },
    updateCurrentKioskMode(state, value) {
      state.currentKioskMode = value;
    },
    updateHasKiosk(state, value) {
      state.hasKiosk = value;
    },
    updateModifierNumber(state, value) {
      state.modifierNumber = value;
    },
    updateIsSafari(state, value) {
      state.isSafari = value;
    },
    updateIsDelivery(state, value) {
      state.isDelivery = value;
    },
    updateisIOSChrome(state, value) {
      state.isIOSChrome = value;
    },
    updateIsIOS(state, value) {
      state.isIOS = value;
    },
    updateCurrentAddressesInSearch(state, value) {
      state.currentAddressesInSearch = value;
    },
    updateLandingPageHash(state, hash) {
      state.landingPageHash = hash;
    },
    updateLandingPage(state, value) {
      state.landingPage = value;
    },
    updateCancelOrder(state, value) {
      state.cancelOrder = value;
    },
    updatePaidFreeItem(state, value) {
      state.paidFreeItem = value;
    },
    startIdleTimer(state) {
      const seconds = process.env.NODE_ENV === "development" ? (state.menu.kiosk_cancel_wait_seconds ? state.menu.kiosk_cancel_wait_seconds : 60) : (state.menu.kiosk_cancel_wait_seconds ? state.menu.kiosk_cancel_wait_seconds : 30);
      state.idleTimer = window.setTimeout(
        () => this["_vm"].$modal.show("time-out"),
        seconds * 1000
      );
    },
    resetIdleTimer(state, allowModal) {
      window.clearTimeout(state.idleTimer);
      allowModal && this.commit("startIdleTimer");
    },
    updateRouteName(state, value) {
      state.routeName = value;
    },
    toggleIdleTimer(state, value) {
      // switch state if no value is given
      state.showIdleTimer = value ? value : !state.showIdleTimer;
    },
    updateItemPrice(state, value) {
      state.itemPrice = value;
    },
    updateSessionId(state, value) {
      state.sessionId = value;
    },
    updateCcvPaying(state, value) {
      state.ccvPaying = value;
    },
    updateScreensaver(state, value) {
      state.screensaver = value;
    },
    updateMinSelectedAddition(state, value) {
      state.minSelectedAddition = value;
    },
    updateMinSelectedAdditionTotal(state, value) {
      state.minSelectedAdditionTotal = value;
    },
    updateMinModifiersCheck(state, value) {
      state.minModifiersCheck.push(value);
    },
    transformMinModifiersCheck(state, value) {
      state.minModifiersCheck = value;
    },
    deleteMinModifiersCheck(state) {
      state.minModifiersCheck = [];
    },
    updateMinSelectedAdditionComboTotal(state, value) {
      state.minSelectedAdditionComboTotal = value;
      // console.log(state.minSelectedAdditionComboTotal);
    },
    updateMinModifierComboCount(state, value) {
      state.minModifierComboCount = value;
    },
    updatePaymentUrl(state, value) {
      state.paymentUrl = value;
    },
    updatePaymentError(state, value) {
      state.paymentError = value;
    },
    updateIsCategorySubItem(state, value) {
      state.isCategorySubItem = value;
    },
    updateLandingsPageDelivery(state, value) {
      state.landingsPageDelivery = value;
    },
    updateInfiniteScroll(state, value) {
      state.infiniteScroll = value;
    },    
    // updateAllRequiredModifersComboDeal(state, value) {
    //   state.allRequiredModifersComboDeal = value;
    // },
  },
  actions: {
    GET_MEMBER_DETAILS({ commit }) {
      return new Promise((resolve, reject) => {
        let data = {
          customer: this.getters.identificationFormData,
        };
        axios
          .post(
            "loyalty/como/get-member-details",
            data
          )
          .then((response) => {
            commit("updateMember", response.data);
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    COMO_PAYMENT({ state, getters,rootGetters }) {
      return new Promise((resolve, reject) => {
        let data = {
          purchase: {
            openTime: getters.menu.created_at,
            transactionId: state.sessionId,
            totalAmount: (rootGetters['Cart/totalPriceValueWithCostsValue'] * 100).toFixed(0),
            items: getters.itemsRestructured,
          },
          customer: {
              customIdentifier: sessionStorage.getItem("comoMemberCode")
          },
          amount: (rootGetters['Cart/loyaltyDiscount'] * 100).toFixed(0),
        };
        axios
          .post(
            "loyalty/como/submit-payment",
            data
          )
          .then((response) => {
            resolve(response);
            state.comoConfirmation = response.data.confirmation
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    COMO_SUBMIT_PURCHASE({ state, getters, rootGetters }) {
      return new Promise((resolve, reject) => {
        let selectedPaymentType = '';
        rootGetters['Cart/availablePaymentTypes'].forEach(type => {
          if (type.Id == state.orderData.PaymentTypeId) {
            selectedPaymentType = type.name_en;
          }
        })
        let memberPoints = ''
        if (JSON.parse(sessionStorage.getItem("comoMember")).creditBalance.usedByPayment) {
          memberPoints = 'creditBalance'
        }
        else if (JSON.parse(sessionStorage.getItem("comoMember")).pointsBalance.usedByPayment) {
          memberPoints = 'pointsBalance'
        }
        let data = {
          customer: [
            {
              customIdentifier: sessionStorage.getItem("comoMemberCode")
            }
          ],
          purchase: {
            openTime: getters.menu.created_at,
            transactionId: sessionStorage.getItem("sessionId"),
            totalAmount: state.orderData.amount * 100,
            orderType: state.orderData.is_order_type_dine_in ? "dineIn" : "takeAway",
            employee: state.orderData.Customer.fullName,
            items: getters.comoSubmitPurchaseItemsRestructured,
        },
         meansOfPayment: [
            {
            "type": memberPoints,
            "amount": state.orderData.loyalty_discount * 100
            },
            {
            "type": selectedPaymentType,
            "amount": state.orderData.amount * 100
            }
        ]
      }
        axios
          .post(
          "loyalty/como/submit-purchase",
            data
          )
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    CREATE_NEW_SESSION_ID({ commit}) {
      let newSessionId = saveNewSessionId("Store > CREATE_NEW_SESSION_ID:479");
      commit('updateSessionId', newSessionId);
    },
    UPDATE_CART_PROCESS({ commit, state, getters }) {
      sessionStorage.setItem("orderChunksExists", true);
      commit("updateProcessBarCurrentItem", 1);
      commit("updateProcessBarIndex", 1);
      commit("updateProcessCurrentName", "Category");
      commit("updateShowPayment", false);
      commit("updateShowForm", false);
      commit("updateShowTable", false);
      commit("updateShowTableManual", false);
      let path;
      let pointer;
      let onClickIndex;
      let routeName;
      let label;
      let processBarUpdate;
      switch (state.processCurrentName) {
        case "Category": {
          if (
            state.menu.timeslots_mode == "general" ||
            state.menu.timeslots_mode == "individual"
          ) {
            if (state.menu.pos_mode == "take-out") {
              commit("updateProcessBarCurrentItem", 1);
              commit("updateProcessBarIndex", 1);
              commit(
                "updateFloatButtonLabel",
                lang["select_time_slot"][getters.language]
              );
              commit(
                "updateProcessCurrentName",
                "TimeSlotSelection"
              );
              commit("updateProcessStack", "TimeSlotSelection");
            } else {
              if (
                state.menu.pos_mode == "table" ||
                state.menu.pos_mode == "table-manual"
              ) {
                if (
                  state.cart.stickerId == 0 ||
                  state.cart.stickerId == null ||
                  state.cart.tableId == null
                ) {
                  commit(
                    "updateFloatButtonLabel",
                    lang["select_table"][getters.language]
                  );

                  commit(
                    "updateProcessCurrentName",
                    "TableSelection"
                  );
                  commit("updateProcessStack", "TableSelection");
                  if (state.menu.pos_mode == "table") {
                    commit("updateShowTable", true);
                  } else {
                    commit("updateShowTableManual", true);
                  }
                } else {
                  if (state.menu.customer_details_disabled == false && state.hasKiosk ? state.menu.is_checkout_name_enabled || state.menu.show_phone_number : true) {
                    commit(
                      "updateFloatButtonLabel",
                      lang["leave_contact_details"][getters.language]
                    );
                    commit(
                      "updateProcessCurrentName",
                      "UserDetails"
                    );
                    commit("updateProcessStack", "UserDetails");
                  } else {
                    commit(
                      "updateFloatButtonLabel",
                      lang["continue_to_payment"][this.language]
                    );
                    commit("updateProcessCurrentName", "Payment");
                    commit("updateProcessStack", "Payment");
                    commit("updateShowPayment", true);
                  }
                }
              }
            }
          } else {
            if (state.menu.pos_mode == "take-out") {
              commit("updateShowTable", false);
              commit("updateShowTableManual", false);
              if (state.menu.customer_details_disabled == false && (state.hasKiosk ? state.menu.is_checkout_name_enabled || state.menu.show_phone_number : true)) {
                commit(
                  "updateFloatButtonLabel",
                  lang["leave_contact_details"][getters.language]
                );
                commit("updateProcessCurrentName", "UserDetails");
                commit("updateProcessStack", "UserDetails");
              } else {
                if (
                (state.menu.timeslots_mode == "simple" ||
                  state.menu.timeslots_mode == "") && (state.hasKiosk ? state.menu.is_checkout_name_enabled || state.menu.show_phone_number : true)
                ) {
                  commit(
                    "updateFloatButtonLabel",
                    lang["leave_contact_details"][getters.language]
                  );
                  commit("updateProcessCurrentName", "UserDetails");
                  commit("updateProcessStack", "UserDetails");
                } else {
                  commit(
                    "updateFloatButtonLabel",
                    lang["continue_to_payment"][getters.language]
                  );
                  commit("updateProcessCurrentName", "Payment");
                  commit("updateProcessStack", "Payment");
                }
              }
            } else {
              if (state.cart.stickerId == 0) {
                path = `/${state.menuHash}/cart/table-selection`;
                commit(
                  "updateFloatButtonLabel",
                  lang["select_table"][getters.language]
                );
                this.$store.commit(
                  "updateProcessCurrentName",
                  "TableSelection"
                );
                this.$store.commit("updateProcessStack", "TableSelection");
                if (this.menu.pos_mode == "table") {
                  this.$store.commit("updateShowTable", true);
                } else {
                  this.$store.commit("updateShowTableManual", true);
                }
              } else {
                if (this.menu.customer_details_disabled == false && (this.hasKiosk ? this.menu.is_checkout_name_enabled || this.menu.show_phone_number : true)) {
                  path = `/${this.menuHash}/cart/user-details`;
                  commit(
                    "updateFloatButtonLabel",
                    lang["leave_contact_details"][getters.language]
                  );
                  commit("updateProcessCurrentName", "UserDetails");
                  commit("updateProcessStack", "UserDetails");
                  commit("updateShowForm", true);
                } else {
                  path = `/${this.menuHash}/cart/payment`;
                  commit("updateShowTable", false);
                  commit("updateShowTableManual", false);
                  commit(
                    "updateFloatButtonLabel",
                    lang["continue_to_payment"][getters.language]
                  );

                  commit(
                    "updateButtonStack",
                    lang["continue_to_payment"][getters.language]
                  );
                  commit("updateProcessCurrentName", "Payment");
                  commit("updateProcessStack", "Payment");
                  commit("updateShowPayment", true);
                }
              }
            }
          }
          return {
            visibility: true,
            EnablePossible: pointer,
            path: path,
            label: label,
            labelPosition: "justify-center",
            showIcon: true,
            showItems: false,
            onClickIndex: onClickIndex,
            routeName: routeName,
            processBarUpdate: processBarUpdate,
          };
        }
      }
    },
    GET_LANDING_PAGE({ commit, state }) {
      return new Promise((resolve, reject) => {
        axios
          .get("GetLandingPage?LandingHash=" + state.landingPageHash)
          .then((response) => {
            commit("updateLandingPage", response.data);
            if (response.data.design){
              if(localStorage.getItem("theme") != response.data.design) {
                commit("setCurrentTheme", response.data.design);
                // location.reload();
              }
            }else{
                commit("setCurrentTheme", 'default');
                // location.reload();
            }
            
            if (response.data.custom_css) {
              commit("Theme/updateCustomThemeAvailability", true);
              commit(
                "Theme/updateCustomThemeVariables",
                JSON.parse(response.data.custom_css)
              );
              localStorage.setItem(
                "customThemeVariables",
                response.data.custom_css
              );
            }
            resolve(response);
          })
          .catch((error) => {
            reject(error.response);
          });
      });
    },
    GET_MENU_ITEMS({ commit, state, getters }) {
      return new Promise((resolve, reject) => {
        axios
          .get(
            "GetMenu?MenuHash=" +
              state.menuHash +
              "&sessionId=" +
              getters.sessionId,
            {
              headers: {
                "Content-Type": "application/json",
                "Cache-Control": "no-cache",
                Pragma: "no-cache",
                Expires: "0",
              },
            }
          )
          .then((response) => {

            // Insert Fonts style is customer_fonts is provided 
            if (response.data.Menu.custom_fonts) {
              document.head.insertAdjacentHTML('beforeend', response.data.Menu.custom_fonts);
            }


            commit(
              "Cart/updateExtraChargeAmount",
              response.data.Menu.charge_amount_when_min_spent
            );
            commit(
              "Cart/updateMinSpent_w_charg_delivery",
              response.data.Menu.min_spent_w_charg_delivery
            );
            commit("menuHashAvailable", true);
            commit("updateCurrency", response.data.Menu.currency);
            commit("updateMenu", response.data.Menu);
            commit(
              "updateMenuCategories",
              response.data.MenuCategories.filter(
                (x) => x.parentCategoryId == 0
              )
            );
            commit("enableOrdering", response.data.Menu.is_ordering_enabled);
            if (response.data.Menu.is_kiosk_mode|| !response.data.Menu.is_kiosk_mode && Router.currentRoute.query.mode) {
              if (!state.hasKiosk) {
                commit("updateHasKiosk", true);
              }
            } else if(state.hasKiosk) {
              commit("updateHasKiosk", false);
            }
            commit(
              "updateOrderingSecurityCodeHash",
              response.data.Menu.ordering_pass_hash
            );
            commit(
              "Cart/updateHomeDeliveryCosts",
              response.data.Menu.delivery_cost
            );
            /** Update available Payment Types when it's available on the API responses. */
            if (response.data.PaymentTypes.length) {
              commit(
                "Cart/updateAvailablePaymentTypes",
                response.data.PaymentTypes
              );
              commit(
                "Cart/updatePaymentTypeId",
                response.data.PaymentTypes[0].Id
              );
            }
            if (response.data.OrderAPI) {
              /** Update Order Status */
              commit("updateOrderStatus", response.data.OrderAPI.orderStatus);
              commit("Cart/updateOrderId", response.data.OrderAPI.orderId);
              /** Update Customer Information */
              if(response.data.OrderAPI.Customer != "No customer"){
                _.map(response.data.OrderAPI.Customer, (value, key) => {
                  commit("Cart/updateCustomer", { field: key, value: value });
                });
              }
              /** Update TableId */

              /** Update Payment Type ID */
              commit(
                "Cart/updatePaymentTypeId",
                response.data.OrderAPI.PaymentTypeId
              );

              /** Update Cart only if Order Status is `New` or `PendingPayment`. */
              let orderStatus = ["New"];
              let orderStatus2 = ["PaymentPending"];

              if (
                orderStatus.includes(response.data.OrderAPI.orderStatus) ||
                orderStatus2.includes(response.data.OrderAPI.orderStatus)
              ) {
                /** Upate Cart Items */
                commit("Cart/emptyCart");
                response.data.OrderAPI.OrderItems.forEach((element) => {
                  let menuItem = element.MenuItem;
                  menuItem["OrderItemAdditions"] = element.OrderItemAdditions;
                  if (!state.cancelOrder) {
                    commit("Cart/addItem", menuItem);
                  }
                });
                if (response.data.OrderAPI.OrderItems.length == 0) {
                  sessionStorage.removeItem("orderChunksExists");
                }
              }
              if (!orderStatus.includes(response.data.OrderAPI.orderStatus)) {
                commit("updateOrderedData", response.data.OrderAPI);
                commit("updateMenuCategories", response.data.MenuCategories)
              }
            }
            if (response.data.OrderAPI.tableId) {
              commit('Cart/updateTableId', response.data.OrderAPI.tableId);
              if (state.Cart.tables.length) {
                let tableObj = state.Cart.tables.find(el => el.Id == response.data.OrderAPI.tableId);
                commit('Cart/updateStickerId', tableObj.stickerId);
              }
            }

            if (response.data.OrderAPI.manual_table_entry) {
              commit('Cart/updateTableManual', response.data.OrderAPI.manual_table_entry);
            }
            
            if (response.data.Menu.design) {
              if(localStorage.getItem('theme')!=response.data.Menu.design){
              commit("setCurrentTheme", response.data.Menu.design);
              // location.reload();
              }
            }else{
              commit("setCurrentTheme", 'default');
              // location.reload();
            }

            if (response.data.Menu.custom_css) {
              commit("Theme/updateCustomThemeAvailability", true);
              commit(
                "Theme/updateCustomThemeVariables",
                JSON.parse(response.data.Menu.custom_css)
              );
              localStorage.setItem(
                "customThemeVariables",
                response.data.Menu.custom_css
              );
            }
            commit("stopPageLoading");
            resolve(response);
          })
          .catch((error) => {
            commit("menuHashAvailable", false);
            reject(error);
          });
      });
    },
    GET_MENU_SUB_CATEGORIES({ commit, state }) {
      commit("loadingItems", true);
      return new Promise((resolve, reject) => {
        axios
          .get(
            "GetCategoryWithSubCategories?MenuHash=" +
              state.menuHash +
              "&CategoryId=" +
              state.categoryId
          )
          .then((response) => {
            commit(
              "updateParentSelectedMenuCategory",
              response.data.MenuCategory
            );
            commit("updateMenuSubCategories", response.data.SubCategories);
            commit("loadingItems", false);
            commit("stopPageLoading");
            resolve(response);
          })
          .catch((error) => {
            commit("loadingItems", false);
            reject(error);
          });
      });
    },
    GET_MENU_CATEGORIES({ commit, state, getters }) {
      return new Promise((resolve, reject) => {
        axios
          .get(
            "GetMenu?MenuHash=" +
              state.menuHash +
              "&sessionId=" +
              getters.sessionId,
            {
              headers: {
                "Content-Type": "application/json",
                "Cache-Control": "no-cache",
                Pragma: "no-cache",
                Expires: "0",
              },
            }
          )
          .then((response) => {
            // commit("");
            commit(
              "Cart/updateExtraChargeAmount",
              response.data.Menu.charge_amount_when_min_spent
            );
            commit(
              "Cart/updateMinSpent_w_charg_delivery",
              response.data.Menu.min_spent_w_charg_delivery
            );
            commit("menuHashAvailable", true);
            commit("updateCurrency", response.data.Menu.currency);
            commit("updateMenu", response.data.Menu);
            commit("enableOrdering", response.data.Menu.is_ordering_enabled)
            if (response.data.Menu.is_kiosk_mode|| !response.data.Menu.is_kiosk_mode && Router.currentRoute.query.mode) {
              if (!state.hasKiosk) {
                commit("updateHasKiosk", true);
              }
            } else if(state.hasKiosk) {
              commit("updateHasKiosk", false);
            }
            commit(
              "updateInfiniteScroll",
              response.data.Menu.enable_infinity_scroll
            );
            if(response.data.Menu.design){
              if(localStorage.getItem('theme')!=response.data.Menu.design){
              commit("setCurrentTheme", response.data.Menu.design);
              // location.reload();
              }
            }else{
              commit("setCurrentTheme", 'default');
              // location.reload();
            }
            /** Temporary for using infinity scroll feature in menu category*/
            // commit("updateMenu", response.data.Menu);

            commit("updateMenuCategories", response.data.MenuCategories);
            /** Update available Payment Types when it's available on the API responses. */
            if (response.data?.PaymentTypes?.length) {
              commit(
                "Cart/updateAvailablePaymentTypes",
                response.data.PaymentTypes
              );
              commit(
                "Cart/updatePaymentTypeId",
                response.data.PaymentTypes[0].Id
              );
            }
            if (response.data.OrderAPI) {
              /** Update Order Status */
              commit("updateOrderStatus", response.data.OrderAPI.orderStatus);
              commit("Cart/updateOrderId", response.data.OrderAPI.orderId);
              /** Update Customer Information */
              if (response.data.OrderAPI.Customer != "No customer") {
                _.map(response.data.OrderAPI.Customer, (value, key) => {
                  commit("Cart/updateCustomer", { field: key, value: value });
                });
              }
              /** Update TableId */

              /** Update Payment Type ID */
              commit(
                "Cart/updatePaymentTypeId",
                response.data.OrderAPI.PaymentTypeId
              );

              /** Update Cart only if Order Status is `New` or `PendingPayment`. */
              let orderStatus = ["New"];
              let orderStatus2 = ["PaymentPending"];

              if (
                orderStatus.includes(response.data.OrderAPI.orderStatus) ||
                orderStatus2.includes(response.data.OrderAPI.orderStatus)
              ) {
                /** Upate Cart Items */
                commit("Cart/emptyCart");
                response.data.OrderAPI.OrderItems.forEach((element) => {
                  let menuItem = element.MenuItem;
                  menuItem["OrderItemAdditions"] = element.OrderItemAdditions;
                  if (!state.cancelOrder) {
                    commit("Cart/addItem", menuItem);
                  }
                });
                if (response.data.OrderAPI.OrderItems.length == 0) {
                  sessionStorage.removeItem("orderChunksExists");
                }
              }
              if (!orderStatus.includes(response.data.OrderAPI.orderStatus)) {
                commit("updateOrderedData", response.data.OrderAPI);
              }
            }
            commit("stopPageLoading")
            resolve(response);
          })
          .catch((err) => {
            commit("stopPageLoading")
            reject(err);
          });
      });
    },
    GET_ALL_MENU_ITEMS({ commit, state }) {
      commit("loadingItems", true);
      return new Promise((resolve, reject) => {
        //TODO get the first MenuCategory for the iPad that for example 'chocolate' is displayed directly
        axios
          .get(`GetAllMenuItems?MenuHash=${state.menuHash}`)
          .then((response) => {
            commit("loadingItems", false);
            commit("updateMenuItems", response.data.MenuItems);
            // commit("updateSelectedMenuCategory", response.data.MenuCategory);
            commit(
              "Cart/updateExtraChargeAmount",
              response.data.Menu.charge_amount_when_min_spent
            );
            commit(
              "Cart/updateMinSpent_w_charg_delivery",
              response.data.Menu.min_spent_w_charg_delivery
            );
            commit("menuHashAvailable", true);
            commit("updateCurrency", response.data.Menu.currency);
            // commit("updateMenu", response.data.Menu);
            // commit("updateMenuCategories", response.data.MenuCategories);
            commit("stopPageLoading");
            commit("enableOrdering", response.data.Menu.is_ordering_enabled);
            if (response.data.Menu.is_kiosk_mode|| !response.data.Menu.is_kiosk_mode && Router.currentRoute.query.mode) {
              if (!state.hasKiosk) {
                commit("updateHasKiosk", true);
              }
            } else if(state.hasKiosk) {
              commit("updateHasKiosk", false);
            }
            commit(
              "updateOrderingSecurityCodeHash",
              response.data.Menu.ordering_pass_hash
            );
            commit(
              "Cart/updateHomeDeliveryCosts",
              response.data.Menu.delivery_cost
            );

            if(response.data.Menu.design){
              if(localStorage.getItem('theme')!=response.data.Menu.design){
              commit("setCurrentTheme", response.data.Menu.design);
              // location.reload();
              }
            }else{
              commit("setCurrentTheme", 'default');
              // location.reload();
            }

            if (response.data.Menu.custom_css) {
              commit("Theme/updateCustomThemeAvailability", true);
              commit(
                "Theme/updateCustomThemeVariables",
                JSON.parse(response.data.Menu.custom_css)
              );
              localStorage.setItem(
                "customThemeVariables",
                response.data.Menu.custom_css
              );
            }
            this.dispatch("GET_MENU_CATEGORIES")
              .then(() => {
                resolve(response);
              })
              .catch((error) => {
                reject(error);
              });
          })
          .catch((error) => {
            commit("loadingItems", false);
            commit("menuHashAvailable", false);
            reject(error);
          });
      });
    },
    GET_CATEGORY({ commit, state }) {
      commit("loadingItems", true);
      return new Promise((resolve, reject) => {
        //TODO get the first MenuCategory for the iPad that for example 'chocolate' is displayed directly
        axios
          .get(
            `GetCategory?MenuHash=${state.menuHash}&CategoryId=${state.categoryId}`
          )
          .then((response) => {
            commit("loadingItems", false);
            commit("updateMenuItems", response.data.MenuItems);
            commit("updateSelectedMenuCategory", response.data.MenuCategory);
            resolve(response);
          })
          .catch((error) => {
            commit("loadingItems", false);
            reject(error);
          });
      });
    },
    GET_CORRECT_MENU_ITEMS({ dispatch, commit, state }) {
      return new Promise((resolve, reject) => {
        if (state.infiniteScroll === undefined) {
          dispatch("GET_MENU_CATEGORIES")
            .then(() => {
              if (state.infiniteScroll) {
                dispatch("GET_ALL_MENU_ITEMS")
                  .then((response) => {
                    commit("updateIsThemeLoading", false);
                    resolve(response);
                  })
                  .catch((error) => {
                    commit("updateIsThemeLoading", false);
                    reject(error);
                  });
              } else if (state.menuHash && state.categoryId) {
                commit('updateCategoryId',state.categoryId)
                dispatch("GET_CATEGORY")
                  .then((response) => {
                    commit("updateIsThemeLoading", false);
                    resolve(response);
                  })
                  .catch((error) => {
                    commit("updateIsThemeLoading", false);
                    reject(error);
                  });
              } else {
                // console.error("Category Id not found");
                  if (!Router.currentRoute.path.includes("/L/")) {
                  let stickerId = Router.currentRoute.params.stickerId;
                  if(stickerId&&!state.Cart.isTablesLoading) {
                      /** Getting tables from the API and changing the  */
                      dispatch("Cart/GET_TABLES").then((tableResponse) => {
                        let tableObject = _.findLast(tableResponse.data, (item) => item.stickerId == stickerId );
                        if (tableObject) {
                          commit("Cart/updateStickerId", tableObject.stickerId);
                          commit("Cart/updateTableId", tableObject.Id);
                        }
                        commit("updateIsThemeLoading", false);
                      }).catch(err => {
                        console.error(err);
                        commit("updateIsThemeLoading", false);
                      });
                  }else {
                    commit("Cart/updateTableId", null);
                    commit("Cart/updateStickerId", 0);
                    commit("updateIsThemeLoading", false);
                  }
                  } else {
                    commit("updateIsThemeLoading", false);
                }
              }
            })
            .catch(() => {
              commit("updateIsThemeLoading", false);
            });
        } else {
          if (state.infiniteScroll) {
            dispatch("GET_ALL_MENU_ITEMS")
              .then((response) => {
                commit("updateIsThemeLoading", false);
                resolve(response);
              })
              .catch((error) => {
                commit("updateIsThemeLoading", false);
                reject(error);
              });
          } else if (state.menuHash && state.categoryId) {
            commit('updateCategoryId',state.categoryId)
            dispatch("GET_CATEGORY")
              .then((response) => {
                commit("updateIsThemeLoading", false);
                resolve(response);
              })
              .catch((error) => {
                commit("updateIsThemeLoading", false);
                reject(error);
              });
          } else {
            // console.error("Category Id not found");
                if (!Router.currentRoute.path.includes("/L/")) {
                  let stickerId = Router.currentRoute.params.stickerId;
                  if(stickerId&&!state.Cart.isTablesLoading) {
                      /** Getting tables from the API and changing the  */
                      dispatch("Cart/GET_TABLES").then((tableResponse) => {
                        let tableObject = _.findLast(tableResponse.data, (item) => item.stickerId == stickerId );
                        if (tableObject) {
                          commit("Cart/updateStickerId", tableObject.stickerId);
                          commit("Cart/updateTableId", tableObject.Id);
                        }
                        commit("updateIsThemeLoading", false);
                      }).catch(err => {
                        console.error(err);
                        commit("updateIsThemeLoading", false);
                      });
                  }else {
                    commit("Cart/updateTableId", null);
                    commit("Cart/updateStickerId", 0);
                    commit("updateIsThemeLoading", false);
                  }
                }
                else {
                  commit("updateIsThemeLoading", false);
                }
          }
        }
      }).catch(() => {
        commit("updateIsThemeLoading", false);
      });
    },
    GET_MENU_SUBITEMS({ commit, state }, menuItemId) {
      commit("loadingItems", true);
      return new Promise((resolve, reject) => {
        axios
          .get(
            `GetMenuItem?MenuHash=${state.menuHash}&CategoryId=${state.categoryId}&MenuItemId=${menuItemId}`
          )
          .then((response) => {
            commit("updateMenuSubItems", response.data.MenuSubItems);
            commit("loadingItems", false);
            resolve(response);
          })
          .catch((error) => {
            commit("loadingItems", false);
            reject(error);
          });
      });
    },
    GET_DISTANCE_ADDRESSES({ commit }) {
      commit("loadingItems", true);
      return new Promise((resolve, reject) => {
        axios
          .get(
            "https://api.mapbox.com/directions/v5/mapbox/driving/3.82626%2C51.092171%3B3.831266%2C51.089958?alternatives=false&geometries=geojson&steps=false&access_token=pk.eyJ1IjoiamVsbGVnZWVycyIsImEiOiJja20xdWZ0bXAybnFjMnBtd3B3dHU4cm00In0.dc4zJF3PlAUGJCYu4Y6Jvw"
          )
          .then((response) => {
            this.info = response;
            resolve(response);
          })
          .catch((error) => {
            commit("loadingItems", false);
            reject(error);
          });
      });
    },
    GET_LAT_LONG_ADDRESS({ commit, state }, address) {
      commit("loadingItems", true);
      return new Promise((resolve, reject) => {
        axios
          .get(
            "https://api.mapbox.com/geocoding/v5/mapbox.places/" +
              address +
              ".json?access_token=pk.eyJ1IjoiamVsbGVnZWVycyIsImEiOiJja20xdWZ0bXAybnFjMnBtd3B3dHU4cm00In0.dc4zJF3PlAUGJCYu4Y6Jvw"
          )
          .then((response) => {
            axios
              .get(
                "https://api.mapbox.com/directions/v5/mapbox/driving/" +
                  state.menu.delivery_base_long +
                  "%2C" +
                  state.menu.delivery_base_lat +
                  "%3B" +
                  response.data.features[0].center[0] +
                  "%2C" +
                  response.data.features[0].center[1] +
                  "?alternatives=false&geometries=geojson&steps=false&access_token=pk.eyJ1IjoiamVsbGVnZWVycyIsImEiOiJja20xdWZ0bXAybnFjMnBtd3B3dHU4cm00In0.dc4zJF3PlAUGJCYu4Y6Jvw"
              )
              .then((responseDistance) => {
                if (responseDistance.data.routes[0].distance) {
                  commit(
                    "updateCalculatedDistanceHomeDelivery",
                    responseDistance.data.routes[0].distance / 1000
                  );
                }
              });
            commit(
              "updateLongAddressClient",
              response.data.features[0].center[0]
            );
            commit(
              "updateLatAddressClient",
              response.data.features[0].center[1]
            );
            this.info = response;
            resolve(response);
            commit(
              "updateCurrentAddressesInSearch",
              response.data.features.map((x) => x.place_name)
            );
          })
          .catch((error) => {
            commit("loadingItems", false);
            reject(error);
          });
      });
    },
    /**
     * Submit Visitor Details to the Server.
     *
     * @param {state} VuexState
     * @param {object} data FormData (Visitor Details - Name & Email)
     */
    SUBMIT_VISITOR_DETAILS({ state }, data) {
      /** Appending MenuID & Current Timestamp before the xhr call. */
      data["MenuId"] = state.menu.Id;
      data["Timestamp"] = new Date();

      return new Promise((resolve, reject) => {
        axios
          .post(`PostVisiterLog`, data)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
  },
  getters: {
    placeholderImage: (state) => {
      if (!state.menu.custom_image_filler_url) return fallbackPlaceholder;
      return state.menu.custom_image_filler_url;
    },
    member: (state) => {
        state.member = JSON.parse(sessionStorage.getItem('comoMember'))
      return state.member
    },
    loyaltyPoints: (state) => {
      if (JSON.parse(sessionStorage.getItem('comoMember'))) {
        if (JSON.parse(sessionStorage.getItem('comoMember')).pointsBalance.usedByPayment) {
          state.loyaltyPoints = JSON.parse(sessionStorage.getItem('comoMember')).pointsBalance.balance.monetary
        }
        else if (JSON.parse(sessionStorage.getItem('comoMember')).creditBalance.usedByPayment) {
          state.loyaltyPoints = JSON.parse(sessionStorage.getItem('comoMember')).creditBalance.balance.monetary
        }
        return state.loyaltyPoints
      }
    },
    identificationFormData: (state) => {
      return state.identificationFormData
  },
    itemsRestructured: (state) => {
      const cartItems = sortCartByAdditions(state.Cart.items);
        let items = [];
        let departmentName = '';
        _.forEach(cartItems, function (value) {
          state.menuCategories.forEach(elem => {
            if (value.cartItem.MenuCategoryId == elem.Id) {
              departmentName = elem.name_en
            }
          })
          items.push({
            quantity: value.amount,
            lineId: value.cartItem.Id,
            code: value.cartItem.Id,
            name: value.cartItem.name_en,
            departmentCode: value.cartItem.MenuCategoryId,
            departmentName: departmentName,
            unitAmount: value.cartItem.price * 100,
            modificationDate: value.cartItem.created_at,
            grossAmount: value.cartItem.price * value.amount * 100,
            netAmount: value.cartItem.price * value.amount * 100,
          });
        })
      return items;
    },
    comoCancelPaymentItemsRestructured: (state) => {
      const cartItems = sortCartByAdditions(state.Cart.items);
        let items = [];
        let departmentName = '';
        _.forEach(cartItems, function (value) {
          state.menuCategories.forEach(elem => {
            if (value.cartItem.MenuCategoryId == elem.Id) {
              departmentName = elem.name_en
            }
          })
          items.push({
            quantity: value.amount,
            lineId: value.cartItem.Id,
            code: value.cartItem.Id,
            name: value.cartItem.name_en,
            departmentCode: value.cartItem.MenuCategoryId,
            departmentName: departmentName,
            grossAmount: value.cartItem.price * value.amount * 100,
            netAmount: value.cartItem.price * value.amount * 100,
          });
        })
      return items;
    },
    comoSubmitPurchaseItemsRestructured: (state) => {
        const cartItems = sortCartByAdditions(state.orderData.OrderItems);
        let items = [];
        let departmentName = '';
        _.forEach(cartItems, function (value) {
          state.menuCategories.forEach(elem => {
            if (value.cartItem.MenuItem.MenuCategoryId == elem.Id) {
              departmentName = elem.name_en
            }
          })
          items.push({
            quantity: value.amount,
            lineId: value.cartItem.MenuItem.Id,
            code: value.cartItem.MenuItem.Id,
            name: value.cartItem.MenuItem.name_en,
            departmentCode: value.cartItem.MenuItem.MenuCategoryId,
            departmentName: departmentName,
            grossAmount: value.cartItem.MenuItem.price * value.amount * 100,
            netAmount: value.cartItem.MenuItem.price * value.amount * 100,
          });
        })
      return items;
    },
    isSearchKiosk: (state) => state.isSearchKiosk,
    searchItemInput: (state) => state.searchItemInput,
    theme: (state) =>
      Object.hasOwnProperty.call(state.themes, state.currentTheme)
        ? state.themes[state.currentTheme]
        : state.themes["default"],
    pageLoading: (state) => state.pageLoading,
    menuHashAvailable: (state) => state.menuHashAvailable,
    loadingItems: (state) => state.loadingItems,
    language: (state) => {
      if (!state.language && localStorage.getItem('language')) {
        state.language = localStorage.getItem('language');
      }
      return state.language;
    },
    currency: (state) => state.currency,
    menuHash: (state) => state.menuHash,
    menu: (state) => state.menu,
    menuSubCategories: (state) => state.menuSubCategories,
    menuCategories: (state) => {
      if (sessionStorage.getItem('isLoyaltyMember') != "false" && sessionStorage.getItem('isLoyaltyMember') != null) {
        return _.orderBy(state.menuCategories, ["order"], ["asc"])
      }
      else {
        let menuCategories = _.orderBy(state.menuCategories, ["order"], ["asc"])
        let newArray = menuCategories.filter(function (el) {
        return el.is_loyalty_category == false
      });
        return newArray
      }

    },
    menuCategoriesCategories: (state) =>
      _.orderBy(state.menuCategoriesCategories, ["order"], ["asc"]),
    menuItems: (state) => _.orderBy(state.menuItems, ["order"], "asc"),
    groupedMenuItems: (state) => {
      if (!state.infiniteScroll) {
        /** This will execute list once, Once we split the app in
         * component we can remove this by defining another component for infinity Scroll.
         */
        return [[]];
      }
      let groupedValues = _.groupBy(
        state.menuItems,
        (el) => el?.MenuCategoryId
      );
      /**List all items based on menu categories order */
      let orderByMenuCategory = state.menuCategories.map((item) => {
        return { Id: item.Id, items: groupedValues[item.Id] };
      });
      return orderByMenuCategory;
    },
    groupedMenuSubItems: (state) =>
      _.chain(state.menuSubItems).groupBy("course").value(),
    visitorName: (state) => state.visitorContactDetails.name,
    visitorEmail: (state) => state.visitorContactDetails.email,
    visitorPhone: (state) => state.visitorContactDetails.phone,
    marketingConsent: (state) => state.visitorContactDetails.marketingConsent,
    orderingEnabled: (state) => state.isOrderingEnabled,
    orderData: (state) => state.orderData,
    orderStatus: (state) => state.orderStatus,
    appUrl: (state) => state.appUrl,
    sessionId: (state) => {
      if (!state.hasKiosk) {
        if (sessionStorage.getItem("sessionId") === null) {
          // sessionStorage.setItem(
          //   "sessionId",
          //   [...Array(30)].map(() => Math.random().toString(36)[2]).join("")
          // );
            state.sessionId=saveNewSessionId("store/index.js getters/sessionId:10985 = sessionId");
          }
          if(state.sessionId!==sessionStorage.getItem("sessionId")) {
            state.sessionId = sessionStorage.getItem("sessionId")
          }
        }
        return state.sessionId;
    },
    selectedMenuCategory: (state) => state.selectedMenuCategory,
    parentSelectedMenuCategory: (state) => state.parentSelectedMenuCategory,
    discountCodeInfo: (state) => state.discountCodeInfo,
    orderingSecurityCodeHash: (state) => state.orderingSecurityCodeHash,
    isListDisplayed: (state) => state.isListDisplayed,
    processBarCurrentItem: (state) => state.processBarCurrentItem,
    currentBottomIcon: (state) => state.currentBottomIcon,
    isCartViewShown: (state) => state.isCartViewShown,
    isMobileDevice: (state) => state.isMobileDevice,
    isSubSubCategory: (state) => state.isSubSubCategory,
    totalDaysVisible: (state) => state.totalDaysVisible,
    languagesCount: (state) => state.languagesCount,
    address: (state) => state.address,
    city: (state) => state.city,
    country: (state) => state.country,
    zip: (state) => state.zip,
    latAddressClient: (state) => state.latAddressClient,
    longAddressClient: (state) => state.longAddressClient,
    calculatedDistanceHomeDelivery: (state) =>
      state.calculatedDistanceHomeDelivery,
    isSwipeOpen: (state) => state.isSwipeOpen,
    showFee: (state) => state.showFee,
    processCurrentName: (state) => state.processCurrentName,
    floatButtonLabel: (state) => state.floatButtonLabel,
    showTable: (state) => state.showTable,
    showPayment: (state) => state.showPayment,
    showForm: (state) => state.showForm,
    showTableManual: (state) => state.showTableManual,
    processStack: (state) => state.processStack,
    buttonStack: (state) => state.buttonStack,
    isCickable: (state) => state.isCickable,
    isKiosk: (state) => state.isKiosk,
    name: (state) => state.name,
    currentHash: (state) => state.currentHash,
    currentKioskMode: (state) => state.currentKioskMode,
    hasKiosk: (state) => state.hasKiosk,
    categoryId: (state) => state.categoryId,
    subCategoryId: (state) => state.subCategoryId,
    processBarIndex: (state) => state.processBarIndex,
    modifierNumber: (state) => state.modifierNumber,
    isSafari: (state) => state.isSafari,
    isDelivery: (state) => state.isDelivery,
    isIOSChrome: (state) => state.isIOSChrome,
    isIOS: (state) => state.isIOS,
    currentAddressesInSearch: (state) => state.currentAddressesInSearch,
    landingPage: (state) => state.landingPage,
    busNumber: (state) => state.busNumber,
    languageLocales: (state) => state.languageLocales,
    cancelOrder: (state) => state.cancelOrder,
    errorEmail: (state) => state.errorEmail,
    upselling: (state) => state.upselling,
    paidFreeItem: (state) => state.paidFreeItem,
    idleTimer: (state) => state.idleTimer,
    showIdleTimerModal: (state) => state.showIdleTimerModal,
    routeName: (state) => state.routeName,
    itemPrice: (state) => state.itemPrice,
    ccvPaying: (state) => state.ccvPaying,
    screenSaver: (state) => state.screensaver,
    minSelectedAddition: (state) => state.minSelectedAddition,
    minSelectedAdditionTotal: (state) => state.minSelectedAdditionTotal,
    minModifiersCheck: (state) => state.minModifiersCheck,
    userAgent: (state) => state.userAgent,
    desktopMode: (state) =>
      state.userAgent.device.type === "desktop" && !state.hasKiosk,
    paymentUrl: (state) => state.paymentUrl,
    paymentError: (state) => state.paymentError,
    isCategorySubItem: (state) => state.isCategorySubItem,
    landingsPageDelivery: (state) => state.landingsPageDelivery,
    infiniteScroll:(state)=>state.infiniteScroll,
    isThemeLoading: (state) => state.isThemeLoading,
    minModifierComboCount: (state) => state.minModifierComboCount,
    // allRequiredModifersComboDeal: (state) => state.allRequiredModifersComboDeal,
    minSelectedAdditionComboTotal: (state) =>
      state.minSelectedAdditionComboTotal,
    comboItemSelectionStep:(state)=>state.comboItemSelectionStep,
    isUpselling:(state)=>state.isUpselling,
    modifierSelectionStep: (state) => state.modifierSelectionStep,
    modifierSelectionIndex: (state) => state.modifierSelectionIndex,
    modifiersSelectionGroups: (state) => state.modifiersSelectionGroups,
    minimumAgeProduct: (state) => state.minimumAgeProduct,
  },

  modules: {
    Cart,
    Theme,
  },
});
